export const RADIO_TYPES = {
  SIMPLE: 'simple',
  LABEL: 'label',
  BOX: 'box',
}
